import { Building, CrossIcon, ProfileDefault } from 'assets/icons';
import StyledInput from 'components/styledInput/StyledInput';
import {
  DEFAULT_TOOL_PROVIDER,
  TOOL_PROVIDERS,
  TOOL_PROVIDER_LABELS,
  normalizeToolProvider,
} from './templateFormData';

const PROVIDER_OPTIONS = TOOL_PROVIDERS.map((toolProvider) => ({
  value: toolProvider,
  label: TOOL_PROVIDER_LABELS[toolProvider],
}));

const ToolProviderSelect = ({ value, onChange, ariaLabel }) => {
  const provider = normalizeToolProvider(value);
  const ProviderIcon = provider === 'company' ? Building : ProfileDefault;

  return (
    <div className="shrink-0">
      {/* Native select for its keyboard support; <option> cannot hold an icon. */}
      <StyledInput
        type="select"
        label={<span className="sr-only">{ariaLabel}</span>}
        value={provider}
        list={PROVIDER_OPTIONS}
        onChange={(event) => onChange(event.target.value)}
        imgFront={<ProviderIcon wh={20} color="#374151" />}
      />
    </div>
  );
};

/** The tools of a job description, and who provides each one. */
const TemplateToolsSection = ({ tools, toolOptions, onChange }) => {
  const selectedNames = tools.map((tool) => tool.name);

  const onNamesChange = (updated) => {
    const checkedNames = updated
      .filter((item) => item.checked)
      .map((item) => item.value);
    // Keep the provider already chosen for a tool that stays selected.
    onChange(
      checkedNames.map((name) => ({
        name,
        providedBy:
          tools.find((tool) => tool.name === name)?.providedBy ||
          DEFAULT_TOOL_PROVIDER,
      }))
    );
  };

  const removeTool = (name) =>
    onChange(tools.filter((tool) => tool.name !== name));

  const onProviderChange = (name, providedBy) =>
    onChange(
      tools.map((tool) => (tool.name === name ? { ...tool, providedBy } : tool))
    );

  return (
    <div className="flex flex-col gap-4">
      <StyledInput
        type="selectMultipleCheckbox"
        isSearchable
        label="Matériel nécessaire"
        value={selectedNames.length > 0 ? selectedNames.join(', ') : '-'}
        list={toolOptions.map((name) => ({
          value: name,
          label: name,
          checked: selectedNames.includes(name),
        }))}
        onChange={onNamesChange}
        dropdownFullWidth
      />
      {tools.length > 0 ? (
        <ul className="flex flex-col gap-2">
          {tools.map((tool) => (
            <li
              key={tool.name}
              className="flex items-center justify-between gap-3 px-3 py-2 border border-gray-100 rounded-lg"
            >
              <span className="min-w-0 ft-sm text-gray-900 break-words">
                {tool.name}
              </span>
              <div className="flex items-center gap-2 shrink-0">
                <ToolProviderSelect
                  value={tool.providedBy}
                  onChange={(providedBy) =>
                    onProviderChange(tool.name, providedBy)
                  }
                  ariaLabel={`Qui fournit ${tool.name} ?`}
                />
                <button
                  type="button"
                  onClick={() => removeTool(tool.name)}
                  className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-100"
                >
                  <span className="sr-only">Retirer {tool.name}</span>
                  <span aria-hidden="true">
                    <CrossIcon wh={20} color="#374151" />
                  </span>
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default TemplateToolsSection;
